import {CdkDragHandle} from '@angular/cdk/drag-drop';
import {ChangeDetectionStrategy, Component, inject, input, ViewEncapsulation} from '@angular/core';
import {ReorderableRowDirective} from './reorderable-row.directive';

@Component({
    selector: 'app-reorderable-row-grip',
    standalone: true,
    imports: [CdkDragHandle],
    template: `
        <button
            type="button"
            class="app-reorderable-row-grip btn text-secondary p-0 border-0"
            cdkDragHandle
            [attr.aria-label]="label()"
            (pointerdown)="row.freezeCellWidths()"
            (pointerup)="row.releaseCellWidths()"
            (pointercancel)="row.releaseCellWidths()"
            (keydown.arrowUp)="moveByGripKey($event, -1)"
            (keydown.arrowDown)="moveByGripKey($event, 1)">
            <i class="bi bi-grip-vertical" aria-hidden="true"></i>
        </button>
    `,
    // Unencapsulated because the drag state classes land on the consumer's rows, outside this view.
    styles: `
        .app-reorderable-rows > .cdk-drag-placeholder {
            opacity: 0.3;
        }

        .app-reorderable-rows > .cdk-drag-animating,
        .app-reorderable-rows.cdk-drop-list-dragging
            > .cdk-drag:not(.cdk-drag-placeholder, .cdk-drag-preview) {
            transition: transform 200ms cubic-bezier(0, 0, 0.2, 1);
        }

        .app-reorderable-rows button.app-reorderable-row-grip {
            cursor: grab;
        }

        button.app-reorderable-row-grip:focus-visible {
            outline: 2px solid var(--bs-primary);
            outline-offset: 2px;
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReorderableRowGripComponent {
    readonly label = input.required<string>();

    protected readonly row = inject(ReorderableRowDirective);

    protected moveByGripKey(event: Event, offset: number): void {
        if (this.row.rows.keyboard() === 'grip') {
            this.row.moveBy(event, offset);
        }
    }
}
